import store from '@/redux';
import * as ProductEditStore from '@/redux/pages/product-edit';
import { parse } from 'query-string';
    
import * as React from 'react';

import { connect } from 'react-redux';

const Toast = require('react-toast-mobile');

class ProductStorage extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            text: props.storage,
            source: parse(this.props.location.search).source
        };
    }
    public render() {
        return (
            <section className="expert-intro">
                <div className="expert-intro-text" >
                    <textarea placeholder="请输入储存条件..." onChange={() => this.inputAction()} value={this.state.text} readOnly={this.state.source === '4'}></textarea>
                </div>
                {
                    this.state.source !== '4' ?
                    <div className="expert-intro-btns">
                        <button className="btn-submit" onClick={() => this.submitAction()}>确定</button>
                    </div> : null
                }                
            </section>
        )
    }

    // 输入
    private inputAction() { 
        this.setState({
            text: (event as any).target.value
        });
    }

    // 提交
    private submitAction() { 

        if (this.state.text === '') {
            return Toast.T.notify('请填写储存条件');
        } else if (this.state.text.length > 4000) { 
            return Toast.T.notify('储存条件最多4000字');
        }

        store.dispatch({
            type: ProductEditStore.types.INPUT,
            data: {
                key: 'storage',
                value: this.state.text
            }
        });

        this.props.history.goBack();

    }
}

const mapStateToProps = (state: any) => { 
    return {
        ...state.productEditReducers
    }
}

export default connect(mapStateToProps)(ProductStorage);